export class AmsBLType {
  constructor(code, name) {
    this.code = code
    this.name = name
  }
}

export const CODE_NAME = 'AmsBLType'

export const OB = new AmsBLType('OB', 'Ocean Bill of Lading')
export const BM = new AmsBLType('BM', 'House Bill of Lading')
export const Ams_BL_Type = [OB, BM]

export function getAmsBLTypeByCode(code) {
  return Ams_BL_Type.find(el => el.code === code)
}
